import { render, staticRenderFns } from "./BackNavbar.vue?vue&type=template&id=562c793d&scoped=true"
import script from "./BackNavbar.vue?vue&type=script&lang=js"
export * from "./BackNavbar.vue?vue&type=script&lang=js"
import style0 from "./BackNavbar.vue?vue&type=style&index=0&id=562c793d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c793d",
  null
  
)

export default component.exports